module.exports = __webpack_public_path__ + "img/icon-location.53b9cd0a.svg";